module.exports = __webpack_public_path__ + "img/HQ-OA-360V05NU.d5751a48.jpg";